/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberCategories } from '../../models/member-categories';
import { MemberCategoriesUpdate } from '../../models/member-categories-update';

export interface UpdateMemberCategoryInternalV2MembersCategoriesIdPatch$Params {
  id: string;
  org: string;
      body: MemberCategoriesUpdate
}

export function updateMemberCategoryInternalV2MembersCategoriesIdPatch(http: HttpClient, rootUrl: string, params: UpdateMemberCategoryInternalV2MembersCategoriesIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MemberCategories>> {
  const rb = new RequestBuilder(rootUrl, updateMemberCategoryInternalV2MembersCategoriesIdPatch.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MemberCategories>;
    })
  );
}

updateMemberCategoryInternalV2MembersCategoriesIdPatch.PATH = '/_internal/v2/members/categories/{id}';
